module.exports = {
  platform: 'voice',
  name: 'Input',
  node: 'input',
  bg: '#FFFFFF',
  note: '',
  property: {
    config: {
      default_input: {
        is_customize_input: false,
        is_count_retry: undefined,
        asr: {},
        nlu: ''
      }
    },
    input_type: 'voice',
    dtmf_setting: {
      terminator_length: 4,
      terminator_timeout: '5.00',
      terminator_char: '#',
      dtmf_barge_in: false
    },
    response: {}
  }
}
